import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ng-nav';
  username = 'rishi';


  lang:any;
  constructor(private translate: TranslateService) {
     // the lang to use, if the lang isn't available, it will use the current loader to get them
     this.translate.setDefaultLang('ar');
     this.lang  =localStorage.getItem('lang') || 'ar';
     this.translate.use( this.lang);
     document.documentElement.lang =  this.lang;
  }

}
